/**
 * FilterControls Component
 * 
 * Reusable filter dropdowns with multi-select support
 * Shared component used by CategoriesList
 */

import React from 'react';
import { ChevronDown } from 'lucide-react';

interface FilterOption {
  value: string;
  label: string;
}

interface FilterConfig {
  key: string;
  label: string;
  options: FilterOption[];
}

interface FilterControlsProps {
  filters: Record<string, any>;
  onFilterChange: (filters: Record<string, any>) => void;
  availableFilters: FilterConfig[];
}

export function FilterControls({ 
  filters, 
  onFilterChange, 
  availableFilters 
}: FilterControlsProps): React.ReactElement {
  const handleFilterChange = (key: string, value: any) => {
    onFilterChange({ ...filters, [key]: value });
  };

  return (
    <div className="flex gap-2">
      {availableFilters.map((filter) => (
        <div key={filter.key} className="relative">
          <select
            value={filters[filter.key] || ''}
            onChange={(e) => handleFilterChange(filter.key, e.target.value)}
            className="appearance-none bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg px-4 py-2 pr-8 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            aria-label={filter.label}
          >
            {filter.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" aria-hidden="true" />
        </div>
      ))}
    </div>
  );
}

